import { useOutletContext } from 'react-router-dom';

export const useStepperContext = () => {
  const { stepper } = useOutletContext<{
    stepper: {
      previous: (replaceParams?: Record<string, string>) => void;
      next: (replaceParams?: Record<string, string>) => void;
      isFirstStep: boolean;
      isLastStep: boolean;
      replaceParams: (params: Record<string, string>, replaceHistory?: boolean) => void;
      isSingleStep: boolean;
      afterEndPath?: string;
      invalidateFutureSteps: () => void;
    };
  }>();

  return stepper;
};

export function stepperNextWithFork({
  stepper,
}: {
  stepper: ReturnType<typeof useStepperContext>;
}) {
  return (result: object) => {
    const { newBranchId } = result as { newBranchId?: string };

    if (newBranchId) {
      stepper.next({
        branchId: newBranchId,
      });
    } else {
      stepper.next();
    }
  };
}
